import { QueryStatus } from '@tanstack/react-query';
import { useTranslations } from 'use-intl';
import { useEffect, useState } from 'react';
import Icon, { Icons } from '@/components/elements/Icon';
import { TokenInterface } from '@/core/tokens';
import { matchVault } from 'nftx.js';
import TokensTable from '../../tables/TokensTable';

export interface TokensProps {
  status: QueryStatus;
  tokens?: TokenInterface[];
}

export const Tokens = ({ tokens, status }: TokensProps) => {
  const [search, setSearch] = useState('');
  const t = useTranslations('Tokens');

  const [filteredTokens, setFilteredTokens] = useState(tokens || []);

  // set on render and search
  useEffect(() => {
    if (tokens) {
      if (search) {
        setFilteredTokens((x) =>
          x?.filter((y) =>
            matchVault(
              {
                asset: {
                  id: y.id,
                  symbol: y.symbol,
                  name: y.name,
                },
                id: y.id,
                token: {
                  id: y.id,
                  name: y.name,
                  symbol: y.symbol,
                },
                vaultId: y.vaultId,
              },
              search
            )
          )
        );
      } else {
        setFilteredTokens(tokens);
      }
    }
  }, [search, tokens]);

  return (
    <article className="space-y-10">
      <header className="flex justify-between items-center">
        <h1 className="text-xl font-bold">{t('title')}</h1>
        <div className="relative group flex-1 max-w-xs">
          <span className="absolute w-5 h-full flex items-center justify-center left-3">
            <Icon
              name={Icons.SEARCH}
              className="text-gray-400 transform transition-transform group-focus-within:scale-105"
              aria-hidden="true"
              size={16}
            />
          </span>
          <input
            type="search"
            name="nftx_v3_search"
            id="nftx_v3_search"
            className="rounded-full h-10 md:h-12 bg-gray-100 block w-full border border-gray-300 py-1.5 pl-10 text-gray-500 placeholder:text-gray-400 placeholder:focus:text-gray-400 focus:outline-none focus:ring-0 focus:border-gray-400/75 text-base focus:bg-gray-50"
            placeholder={t('search')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </header>

      <TokensTable status={status} tokens={filteredTokens} />
    </article>
  );
};

export default Tokens;
